import type { Arrangement, PlanDetail, PlanItem, SongDetail } from "../../../shared/types";

export function practiceFrom(song: SongDetail): PlanDetail {
  const arrangement = song.arrangements.find((item) => item.isDefault) ?? song.arrangements[0];
  const item = practiceItem(song, arrangement);
  const start = new Date().toISOString();
  return {
    id: song.id,
    title: song.title,
    serviceTypeId: "practice",
    serviceTypeName: "Practice",
    serviceTypeColor: "#8b6cff",
    startsAt: start,
    endsAt: start,
    status: "draft",
    notes: "Practice chart for this song. It is not a service plan.",
    publicNotes: "",
    series: null,
    items: [item],
    teams: [],
    rehearsals: [],
    totalSeconds: 0,
  };
}

function practiceItem(song: SongDetail, arrangement: Arrangement | undefined): PlanItem {
  return {
    id: `practice-${song.id}`,
    planId: song.id,
    position: 0,
    kind: "song",
    title: song.title,
    songId: song.id,
    arrangementId: arrangement?.id ?? null,
    arrangementName: arrangement?.name ?? null,
    keyName: arrangement?.keyName ?? song.defaultKey,
    songDefaultKey: song.defaultKey,
    bpm: arrangement?.bpm ?? song.bpm,
    meter: arrangement?.meter ?? song.meter,
    durationSeconds: 0,
    startsAt: new Date().toISOString(),
    leaderPersonId: null,
    leaderName: null,
    description: song.notes,
    chordpro: arrangement?.chordpro ?? "",
    attachments: song.attachments,
  };
}
